import { z } from "zod";
import { DateTime } from "luxon";

const isoDateString = z
	.string()
	.refine((val) => DateTime.fromISO(val).isValid, { message: "Must be a valid ISO 8601 date string" });

const orderAuditEventSchema = z.object({
	eventType: z.string(),
	eventDate: isoDateString,
	correlationId: z.string(),
	jobId: z.string().optional(),
});

export const orderAuditSchema = z.object({
	id: z.string(),
	tenantId: z.string(),
	orderId: z.string(),
	pickTicketId: z.string(),
	events: z.array(orderAuditEventSchema),
	firstEventDate: isoDateString,
	lastEventDate: isoDateString,
	correlationIds: z.array(z.string()),
});

export type OrderAuditEvent = z.infer<typeof orderAuditEventSchema>;
export type OrderAudit = z.infer<typeof orderAuditSchema>;
